<template>
  <div class="container">
    <div class="container">
      <div class="row">
        <div class="col-sm-10">
          <table class="table table-bordered">
            <thead class="table-light">
              <tr>
                <th>รอบ</th>
                <th>ผลลัพธ์การบีบมือ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="h in user.hand" :key="h.id">
                <td>การบีบมือครั้งที่ {{ h.set_of_activities }}</td>
                <td>
                  <span v-if="h.is_success">สำเร็จ</span>
                  <span v-else>ไม่สำเร็จ</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="row">
            <div class="col-md-12">
              <div class="card mt-3">
                <button
                  type="button"
                  class="btn btn-success btn-lg"
                  style="width:100%"
                  @click="openStartRecording"
                  :disabled="!canOpenStartCamera"
                >
                  เปิดกล้องมือถือเพื่อทำการบันทึกวิดีโอเวลา 10 วินาทีอัตโนมัติ
                </button>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card mt-3">
                <button
                  type="button"
                  class="btn btn-success btn-lg"
                  style="width:100%"
                  :disabled="!canStartProgram"
                  @click="startHandProgram"
                >
                  เริ่มต้นการบีบมือ
                </button>
              </div>
            </div>

            <div class="col-md-6">
              <div class="card mt-3">
                <button
  type="button"
  class="btn btn-danger btn-lg"
  style="width:100%"
        :disabled="!canFinishRoundEarly"
  @click="finishCurrentRoundEarly"
>
  คลิกเมื่อทำรอบนี้เสร็จแล้ว
</button>
              </div>
            </div>

            <div class="col-md-12">
              <div class="card mt-3">
                <button
                  type="button"
                  class="btn btn-secondary btn-lg"
                  style="width:100%"
                  :disabled="!canFinishProgram"
                  @click="openFinishDialog"
                >
                  คลิกที่นี่เมื่อดำเนินกิจกรรมทั้งหมดแล้วเสร็จ
                </button>
              </div>
            </div>

            <div
              class="col-md-12 mt-3"
              v-if="showCamera && (handPhase === 'recording_start' || handPhase === 'recording_finish')"
            >
              <video ref="previewhand" autoplay playsinline muted width="320"></video>

              <div v-if="countdownVisible" class="countdown-box">
                {{ handPhase === "recording_start" ? "กำลังบันทึกวิดีโอเริ่มต้น" : "กำลังบันทึกวิดีโอสิ้นสุด" }}
                {{ recordCountdown }} วินาที
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-2">
          <button type="button" class="btn btn-secondary btn-lg" style="width:100%">
            {{ handProgressText }}
            <p>{{ phaseLabel }}</p>
            <p>{{ timeLeft }}</p>
          </button>
        </div>
      </div>

      <div v-if="showFinishDialog" class="symptom-modal">
        <div class="symptom-modal-content">
          <h4>กรอกอาการหลังออกกำลังกาย</h4>
          <textarea
            v-model="after_message"
            class="form-control"
            rows="4"
            placeholder="เช่น เหนื่อยเล็กน้อย เวียนหัว ปวดแขน หรือไม่มีอาการ"
          ></textarea>

          <div style="margin-top:15px; display:flex; gap:10px; justify-content:center;">
            <button class="btn btn-secondary" @click="closeFinishDialog">ยกเลิก</button>
            <button class="btn btn-primary" @click="confirmFinishAndRecordHand">ยืนยันและบันทึกวิดีโอ</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ParticipantService from "../services/ParticipantService";
import ParticipantsActivitiesService from "../services/ParticipantsActivitiesService";
import ActivitiesService from "../services/ActivitiesService";
import LinkService from "../services/LinkService";

import axios from "axios";

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  data() {
    return {
      data: {},
      user: {},
      hand: {},
      id: 0,

      busy: false,
      cameraOn: false,
      recording: false,
      showCamera: false,

      videoUrlHand: null,
      stream: null,
      recorder: null,
      chunks: [],
      stopTimerId: null,

      handRoundsTarget: 4,
      currentRound: 1,
      currentRoundRecordId: null,

      handPhase: "idle", // idle | recording_start | squeezing | resting | ready_finish | recording_finish | done
      phaseSecondsLeft: 120,
      phaseTimer: null,

      showFinishDialog: false,
      after_message: "",

      todayHandRecords: [],
      latestHandSet: 0,
      nextHandSet: 1,

      recordCountdown: 10,
      countdownVisible: false,
      countdownTimerId: null,

      hasStartVideoToday: false,
      pendingStartRecordId: null,
      startButtonLocked: true,
    };
  },
  mounted() {
    const key = "device_id";
    this.id = localStorage.getItem(key);

    this.getHand();    
    if (this.id) {
      this.getActivity(this.id);
    }
  },
  beforeDestroy() {
    this.clearPhaseTimer();
    this.stopRecordCountdown();
    this.stopAll();
    if (this.videoUrlHand) {
      URL.revokeObjectURL(this.videoUrlHand);
    }
  },
  methods: {
    async openStartRecording() {
      if (!this.canOpenStartCamera) return;
      this.handPhase = "recording_start";
      await this.startAndRecordHand("start");
    },

    async startHandProgram() {
  if (!this.canStartProgram) return;

  this.clearPhaseTimer();
  this.currentRound = this.nextHandSet || 1;

  // รอบ 1: มี start video แล้ว แต่ยังไม่มี started_at
  if (this.currentRound === 1 && this.pendingStartRecordId) {
    try {
      const res = await ParticipantsActivitiesService.updateparticipants_activitie(
        this.pendingStartRecordId,
        {
          started_at: new Date(),
        }
      );

      const updatedRecord = res.data;

      this.currentRoundRecordId = updatedRecord.id;
      this.pendingStartRecordId = null;
      this.startButtonLocked = true;
      this.beginSqueezeRound();

      const idx = this.todayHandRecords.findIndex(item => item.id === updatedRecord.id);
      if (idx !== -1) {
        this.$set(this.todayHandRecords, idx, {
          ...this.todayHandRecords[idx],
          ...updatedRecord,
        });
      }

    } catch (err) {
      console.error(err);
    }
    return;
  }

  // รอบ 1: มี record ของวันนี้อยู่แล้ว และมี start_record_path แล้ว
  if (this.currentRound === 1 && this.currentRoundRecordId && this.hasStartVideoToday) {
    this.startButtonLocked = true;
    this.beginSqueezeRound();
    return;
  }

  // รอบ 2-4
  this.startRound(this.currentRound);
},

    startRecordCountdown(durationSec = 10) {
      this.recordCountdown = durationSec;
      this.countdownVisible = true;
      this.stopRecordCountdown();

      this.countdownVisible = true;
      this.recordCountdown = durationSec;

      this.countdownTimerId = setInterval(() => {
        if (this.recordCountdown > 0) {
          this.recordCountdown--;
        } else {
          this.stopRecordCountdown();
        }
      }, 1000);
    },

    stopRecordCountdown() {
      if (this.countdownTimerId) {
        clearInterval(this.countdownTimerId);
        this.countdownTimerId = null;
      }
      this.countdownVisible = false;
      this.recordCountdown = 10;
    },

    clearPhaseTimer() {
      if (this.phaseTimer) {
        clearInterval(this.phaseTimer);
        this.phaseTimer = null;
      }
    },

    beginSqueezeRound() {
  this.clearPhaseTimer();
  this.handPhase = "squeezing";
  this.phaseSecondsLeft = 120;

  this.phaseTimer = setInterval(() => {
    if (this.phaseSecondsLeft > 0) {
      this.phaseSecondsLeft--;
    } else {
      this.clearPhaseTimer();
      // this.beginRestPhase();
    }
  }, 1000);
},
getLocalDateYMD() {
  return this.formatLocalDateYMD(new Date());
},

formatLocalDateYMD(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
},
beginRestPhase() {
  this.clearPhaseTimer();
  this.handPhase = "resting";
  this.phaseSecondsLeft = 60;
  this.startButtonLocked = true;

  this.phaseTimer = setInterval(() => {
    if (this.phaseSecondsLeft > 0) {
      this.phaseSecondsLeft--;
    } else {
      this.clearPhaseTimer();

      if (this.currentRound >= this.handRoundsTarget) {
        this.handPhase = "ready_finish";
        this.phaseSecondsLeft = 0;
        this.nextHandSet = null;
        this.startButtonLocked = true;
        return;
      }

      this.currentRound = this.currentRound + 1;
      this.nextHandSet = this.currentRound;
      this.handPhase = "idle";
      this.phaseSecondsLeft = 120;
      this.startButtonLocked = false;
    }
  }, 1000);
},

    finishCurrentRoundEarly() {
  if (this.handPhase !== "squeezing") {
    alert("กรุณาเริ่มการบีบมือก่อน");
    return;
  }

  this.finishCurrentRound();
},

finishCurrentRound() {
  this.clearPhaseTimer();
  this.phaseSecondsLeft = 0;

  if (!this.currentRoundRecordId) {
    console.error("currentRoundRecordId not found");
    return;
  }

  const currentRecord = this.todayHandRecords.find(
    (item) => item.id === this.currentRoundRecordId
  );

  if (!currentRecord || !currentRecord.started_at) {
    console.error("started_at not found");
    return;
  }

  const finishedAt = new Date();
  const startedAt = new Date(currentRecord.started_at);
  const durationSeconds = Math.floor((finishedAt - startedAt) / 1000);
  const isSuccess = durationSeconds >= 120;
  // console.log(durationSeconds,'durationSeconds');
  // console.log(isSuccess,'isSuccess');
  
  

  if (this.currentRound === 4) {
    this.handPhase = "ready_finish";
    this.nextHandSet = null;
    this.startButtonLocked = true;
    return;
  }

  ParticipantsActivitiesService.updateparticipants_activitie(this.currentRoundRecordId, {
    finished_at: finishedAt,
    duration: durationSeconds,
    is_success: isSuccess,
  })
    .then((res) => {
      const updatedRecord = res.data;

      const idx = this.todayHandRecords.findIndex(item => item.id === updatedRecord.id);
      if (idx !== -1) {
        this.$set(this.todayHandRecords, idx, {
          ...this.todayHandRecords[idx],
          ...updatedRecord,
        });
      }

      const idx2 = (this.user.hand || []).findIndex(item => item.id === updatedRecord.id);
      if (idx2 !== -1) {
        this.$set(this.user.hand, idx2, {
          ...this.user.hand[idx2],
          ...updatedRecord,
        });
      }

      this.latestHandSet = this.currentRound;
      this.currentRoundRecordId = null;
      this.beginRestPhase();
    })
    .catch((err) => {
      console.error(err);
    });
},

    openFinishDialog() {
      if (this.handPhase !== "ready_finish") return;
      this.showFinishDialog = true;
    },

    closeFinishDialog() {
      this.showFinishDialog = false;
    },

    async confirmFinishAndRecordHand() {
      if (!this.after_message || !this.after_message.trim()) {
        alert("กรุณากรอกอาการหลังออกกำลังกาย");
        return;
      }

      if (!this.currentRoundRecordId) {
        alert("ไม่พบข้อมูลรอบที่ 4");
        return;
      }

      this.showFinishDialog = false;
      this.handPhase = "recording_finish";
      await this.startAndRecordHand("finish");
    },

    getRoundRecord(roundNumber) {
      return (
        this.todayHandRecords.find(
          (item) => Number(item.set_of_activities) === Number(roundNumber)
        ) || null
      );
    },

    getLatestFinishedRound(records) {
      const finished = (records || []).filter(
        (item) =>
          Number(item.set_of_activities) >= 1 &&
          Number(item.set_of_activities) <= 4 &&
          !!item.finished_at
      );

      if (!finished.length) return 0;

      return finished.reduce((max, item) => {
        const round = Number(item.set_of_activities || 0);
        return round > max ? round : max;
      }, 0);
    },

    getTodayHandRecords(records) {
  const today = this.getLocalDateYMD();

  return (records || []).filter((r) => {
    if (!r.activity_date) return false;

    const d = new Date(r.activity_date);
    const ymd = this.formatLocalDateYMD(d);

    return ymd === today;
  });
},

async getActivity(id) {
  try {
    const participantRes = await ParticipantService.get_participant(id);
    if (participantRes.status !== 200) return;

    this.user = participantRes.data;

    const activityRes = await ParticipantService.get_participant_by_imei(this.user.id);
    if (activityRes.status !== 200) return;

    const handRecords = activityRes.data.filter(
      (i) =>
        i.activity_id === 2 &&
        Number(i.set_of_activities) >= 1 &&
        Number(i.set_of_activities) <= 4
    );

    this.$set(this.user, "hand", handRecords);
    // console.log(handRecords,'handRecords');
    
    this.todayHandRecords = this.getTodayHandRecords(handRecords);

    const round1Record = this.getRoundRecord(1);
    // console.log(round1Record,'11');
    

    const unfinishedRound = this.todayHandRecords
      .filter((i) => !i.finished_at)
      .sort((a, b) => Number(a.set_of_activities) - Number(b.set_of_activities))[0];

    this.latestHandSet = this.getLatestFinishedRound(this.todayHandRecords);
    this.nextHandSet = this.latestHandSet >= 4 ? null : this.latestHandSet + 1;

    this.hasStartVideoToday = !!(round1Record && round1Record.start_record_path);

    this.pendingStartRecordId =
      round1Record && round1Record.start_record_path && !round1Record.started_at
        ? round1Record.id
        : null;

    // วันนี้ยังไม่มี record เลย
    if (!this.todayHandRecords.length) {
      this.currentRound = 1;
      this.currentRoundRecordId = null;
      this.handPhase = "idle";
      this.phaseSecondsLeft = 120;
      this.startButtonLocked = true; // ต้องอัด start video ก่อน
      this.hasStartVideoToday = false;
      this.pendingStartRecordId = null;
      return;
    }

    // ถ้ามี start_record_path ของรอบแรกแล้วในวันนี้ ให้เริ่มได้เลย
    if (round1Record && round1Record.start_record_path && !round1Record.finished_at) {
      this.currentRound = 1;
      this.currentRoundRecordId = round1Record.id;
      this.handPhase = "idle";
      this.phaseSecondsLeft = 120;
      this.startButtonLocked = false;
      this.nextHandSet = 1;
      this.pendingStartRecordId = !round1Record.started_at ? round1Record.id : null;
      return;
    }

    // มีรอบค้าง started แล้วแต่ยังไม่ finished
    if (unfinishedRound) {
      this.currentRound = Number(unfinishedRound.set_of_activities);
      this.currentRoundRecordId = unfinishedRound.id;

      if (unfinishedRound.started_at && !unfinishedRound.finished_at) {
        if (this.currentRound === 4) {
          this.handPhase = "squeezing";
          this.phaseSecondsLeft = this.phaseSecondsLeft > 0 ? this.phaseSecondsLeft : 120;
          this.startButtonLocked = true;
          this.nextHandSet = null;
          this.latestHandSet = 3;
        } else {
          this.handPhase = "squeezing";
          this.phaseSecondsLeft = this.phaseSecondsLeft > 0 ? this.phaseSecondsLeft : 120;
          this.startButtonLocked = true;
          this.nextHandSet = this.currentRound;
          this.latestHandSet = this.currentRound - 1;
        }
        return;
      }

      if (this.currentRound === 4) {
        this.handPhase = "ready_finish";
        this.phaseSecondsLeft = 0;
        this.startButtonLocked = true;
        this.latestHandSet = 3;
        this.nextHandSet = null;
      } else {
        this.handPhase = "idle";
        this.phaseSecondsLeft = 120;
        this.startButtonLocked = false;
        this.nextHandSet = this.currentRound;
        this.latestHandSet = this.currentRound - 1;
      }
      return;
    }

    // ทำครบแล้ว
    if (this.latestHandSet >= 4) {
      this.currentRound = 4;
      this.currentRoundRecordId = null;
      this.handPhase = "done";
      this.phaseSecondsLeft = 0;
      this.startButtonLocked = true;
      this.nextHandSet = null;
      return;
    }

    // จบรอบก่อนหน้าแล้ว รอเริ่มรอบถัดไป
    this.currentRound = this.nextHandSet || 1;
    this.currentRoundRecordId = null;
    this.handPhase = "idle";
    this.phaseSecondsLeft = 120;
    this.startButtonLocked = false;
  } catch (error) {
    console.log(error);
  }
},

    createHandRoundRecord(roundNumber, extraPayload = {}) {
      return ParticipantsActivitiesService.create_participants_activitie({
        participant_id: this.user.id,
        activity_id: 2,
        monitoring_number_id: this.user.monitoring_number_id,
        round: this.user.round_hand || 1,
        set_of_activities: roundNumber,
        started_at: new Date(),
        activity_date: this.getLocalDateYMD(),
        ...extraPayload,
      });
    },

    // startRound(roundNumber, extraPayload = {}) {
    //   this.clearPhaseTimer();
    //   this.phaseSecondsLeft = 120;

    //   return this.createHandRoundRecord(roundNumber, extraPayload)
    //     .then((res) => {
    //       this.currentRound = roundNumber;
    //       this.currentRoundRecordId = res.data.id;
    //       this.handPhase = "squeezing";
    //       this.showCamera = false;
    //       this.startButtonLocked = true;

    //       this.beginSqueezeRound();
    //       // this.getActivity(this.id);
    //     })
    //     .catch((err) => {
    //       console.error(err);
    //     });
    // },
    startRound(roundNumber, extraPayload = {}) {
  this.clearPhaseTimer();
  this.phaseSecondsLeft = 120;

  return this.createHandRoundRecord(roundNumber, extraPayload)
    .then((res) => {
      const newRecord = res.data;

      this.currentRound = roundNumber;
      this.currentRoundRecordId = newRecord.id;
      this.handPhase = "squeezing";
      this.showCamera = false;
      this.startButtonLocked = true;

      // อัปเดต state ฝั่งหน้าให้มี record ล่าสุดทันที
      this.todayHandRecords.push(newRecord);

      if (!this.user.hand) {
        this.$set(this.user, "hand", []);
      }
      this.user.hand.push(newRecord);

      this.beginSqueezeRound();
    })
    .catch((err) => {
      console.error(err);
    });
},
    getHand() {
      ActivitiesService.getactivity(2).then((res) => {
        this.hand = res.data;
        this.hand_per_week = res.data.finish_number_per_week;
        // console.log(this.hand,'hand');
        
      });
    },

    async startAndRecordHand(mode = "start") {
      if (this.busy) return;
      this.busy = true;

      try {
        if (this.videoUrlHand) {
          URL.revokeObjectURL(this.videoUrlHand);
          this.videoUrlHand = null;
        }

        this.showCamera = true;
        await this.$nextTick();

        this.stream = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true,
        });

        if (this.$refs.previewhand) {
          this.$refs.previewhand.srcObject = this.stream;
          if (this.$refs.previewhand.play) {
            await this.$refs.previewhand.play().catch(() => {});
          }
        }

        this.cameraOn = true;
        this.startRecordingNowHand(mode);
        this.startRecordCountdown(10);

        this.stopTimerId = window.setTimeout(() => {
          this.stopRecording();
          this.stopAll();
        }, 10000);
      } catch (err) {
        console.error(err);
        alert("เปิดกล้อง/อัดวิดีโอไม่ได้ กรุณาอนุญาตกล้องและไมค์");
      } finally {
        this.busy = false;
      }
    },

    startRecordingNowHand(mode = "start") {
      if (!this.stream) return;

      this.chunks = [];

      let options = {};
      const preferredMime = "video/webm;codecs=vp8,opus";
      if (window.MediaRecorder && MediaRecorder.isTypeSupported(preferredMime)) {
        options = { mimeType: preferredMime };
      }

      this.recorder = new MediaRecorder(this.stream, options);

      this.recorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) {
          this.chunks.push(e.data);
        }
      };

      this.recorder.onstop = async () => {
        const blob = new Blob(this.chunks, {
          type: this.recorder.mimeType || "video/webm",
        });

        this.videoUrlHand = URL.createObjectURL(blob);

        const fileName = `video_hand_${this.user.id}_${Date.now()}.webm`;

        const formData = new FormData();
        formData.append("file", blob, fileName);
        formData.append("name", fileName);

        try {
          await axios.post(
            LinkService.getLink() + `/uploadvideo?name=hand/${mode}_${fileName}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (mode === "start") {
            this.afterStartHandVideoSaved(fileName);
          } else {
            this.afterFinishHandVideoSaved(fileName);
          }
        } catch (err) {
          console.error("Upload error:", err);
        }
      };

      this.recorder.start();
      this.recording = true;
    },

    afterStartHandVideoSaved(fileName) {
      ParticipantsActivitiesService.create_participants_activitie({
        participant_id: this.user.id,
        activity_id: 2,
        monitoring_number_id: this.user.monitoring_number_id,
        round: this.user.round_hand || 1,
        set_of_activities: 1,
        start_record_path: `/uploads/hand/start_${fileName}`,
        activity_date: this.getLocalDateYMD(),
      })
        .then((res) => {
          this.pendingStartRecordId = res.data.id;
          this.currentRound = 1;
          this.currentRoundRecordId = res.data.id;
          this.handPhase = "idle";
          this.phaseSecondsLeft = 120;
          this.showCamera = false;
          this.startButtonLocked = false;
          this.hasStartVideoToday = true;
          

          alert("บันทึกวิดีโอเริ่มต้นสำเร็จ สามารถเริ่มต้นการบีบมือได้");
          // this.getActivity(this.id);
        })
        .catch((err) => {
          console.error(err);
        });
    },

    afterFinishHandVideoSaved(fileName) {
  if (!this.currentRoundRecordId) {
    console.error("currentRoundRecordId not found");
    return;
  }

  const currentRecord = this.todayHandRecords.find(
    (item) => item.id === this.currentRoundRecordId
  );

  if (!currentRecord || !currentRecord.started_at) {
    console.error("started_at not found");
    return;
  }

  const finishedAt = new Date();
  const startedAt = new Date(currentRecord.started_at);
  const durationSeconds = Math.floor((finishedAt - startedAt) / 1000);
  const isSuccess = durationSeconds >= 3;
  // console.log(isSuccess,'isSuccessafter');
  // console.log(durationSeconds,'durationSecondsafter');
  
  

  ParticipantsActivitiesService.updateparticipants_activitie(this.currentRoundRecordId, {
    finished_at: finishedAt,
    end_record_path: `/uploads/hand/finish_${fileName}`,
    after_message: this.after_message,
    duration: durationSeconds,
    is_success: isSuccess,
  })
    .then((res) => {
      const updatedRecord = res.data;

      const idx = this.todayHandRecords.findIndex(item => item.id === updatedRecord.id);
      if (idx !== -1) {
        this.$set(this.todayHandRecords, idx, {
          ...this.todayHandRecords[idx],
          ...updatedRecord,
        });
      }

      const idx2 = (this.user.hand || []).findIndex(item => item.id === updatedRecord.id);
      if (idx2 !== -1) {
        this.$set(this.user.hand, idx2, {
          ...this.user.hand[idx2],
          ...updatedRecord,
        });
      }
      const messageObj = this.getEncourageMessage();
  if (messageObj) {
    alert(messageObj.message);
  }
      // alert("บันทึกวิดีโอและอาการหลังออกกำลังกายสำเร็จ");
      this.resetHandProgram();
      this.getActivity(this.id);
    })
    .catch((err) => {
      console.error(err);
    });
},
getEncourageMessage() {
  const encourageMessages = JSON.parse(this.hand.encourage_message);

  // เอารอบ 1-4 ของวันนี้
  const rounds = (this.todayHandRecords || [])
    .filter(item => Number(item.set_of_activities) >= 1 && Number(item.set_of_activities) <= 4)
    .sort((a, b) => Number(a.set_of_activities) - Number(b.set_of_activities));

  // ถ้าครบ 4 รอบ และสำเร็จทั้งหมด
  const allSuccess =
    rounds.length === 4 &&
    rounds.every(item => Number(item.is_success) === 1 || item.is_success === true);

  if (allSuccess) {
    return encourageMessages.find(m => m.no === 4);
  }

  // ถ้าไม่สำเร็จ ให้เช็ครอบแรกที่ไม่สำเร็จ
  const failedRound = rounds.find(
    item => Number(item.is_success) !== 1 && item.is_success !== true
  );

  if (failedRound) {
    return encourageMessages.find(
      m => m.no === Number(failedRound.set_of_activities)
    );
  }

  return null;
},
    resetHandProgram() {
      this.clearPhaseTimer();
      this.stopRecordCountdown();

      this.handPhase = "done";
      this.phaseSecondsLeft = 0;
      this.showCamera = false;
      this.currentRoundRecordId = null;
      this.pendingStartRecordId = null;
      this.startButtonLocked = true;
      this.after_message = "";
      this.nextHandSet = null;
      this.latestHandSet = 4;
    },

    stopRecording() {
      if (this.stopTimerId) {
        clearTimeout(this.stopTimerId);
        this.stopTimerId = null;
      }

      this.stopRecordCountdown();

      if (this.recorder && this.recorder.state !== "inactive") {
        this.recorder.stop();
      }

      this.recording = false;
    },

    async stopAll() {
      if (this.recording) {
        this.stopRecording();
      }

      if (this.stream) {
        this.stream.getTracks().forEach((t) => t.stop());
        this.stream = null;
      }

      if (this.$refs.previewhand && this.$refs.previewhand.srcObject) {
        this.$refs.previewhand.srcObject = null;
      }

      this.cameraOn = false;
    },

    formatThaiDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString("th-TH", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    phaseLabel() {
      switch (this.handPhase) {
        case "recording_start":
          return "กำลังบันทึกวิดีโอเริ่มต้น";
        case "squeezing":
          return `กำลังบีบมือ รอบที่ ${this.currentRound}`;
        case "resting":
          return `กำลังพัก 1 นาที ก่อนเริ่มรอบที่ ${this.currentRound + 1}`;
        case "ready_finish":
          return "ครบ 4 รอบแล้ว กรุณากดจบกิจกรรม";
        case "recording_finish":
          return "กำลังบันทึกวิดีโอสิ้นสุด";
        case "done":
          return "เสร็จสิ้นกิจกรรม";
        default:
          return "พร้อมเริ่มกิจกรรม";
      }
    },
    timeLeft() {
      const minutes = Math.floor(this.phaseSecondsLeft / 60);
      const seconds = this.phaseSecondsLeft % 60;
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },
    handProgressText() {
      return `ทำแล้ว ${this.latestHandSet} / 4 รอบ`;
    },
    canOpenStartCamera() {
      if (this.busy) return false;
      return !this.hasStartVideoToday && this.todayHandRecords.length === 0;
    },
    canStartProgram() {
  if (this.busy) return false;
  if (this.handPhase !== "idle") return false;

  // ถ้ามี start video ของวันนี้ในรอบแรกแล้ว ให้กดเริ่มได้เลย
  if (this.currentRound === 1 && this.hasStartVideoToday) return true;

  if (this.startButtonLocked) return false;
  return this.nextHandSet !== null;
},
    canFinishRoundEarly() {
  if (this.busy) return false;

  if (this.handPhase === "idle") return false;

  return this.handPhase === "squeezing";
},
    canFinishProgram() {
      return this.handPhase === "ready_finish";
    },
  },
};
</script>

<style scoped>
.countdown-box {
  margin-top: 12px;
  font-size: 22px;
  font-weight: bold;
  color: #dc3545;
}

.symptom-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.symptom-modal-content {
  background: #fff;
  width: 90%;
  max-width: 500px;
  border-radius: 12px;
  padding: 20px;
}
</style>